import { Dialog, DialogContent, styled as muiStyled, Paper } from '@mui/material'
import { PRINT_PAGE_TYPES } from 'src/consumer/constants'

export const ReceiptPrintDialog = muiStyled(Dialog)(
  ({ theme }) => `
  @media print {
    .MuiDialog-container {
      height: 100% !important;
    }
    height: 100% !important;
  }
`,
)

export const ReceiptPrintDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  @media print {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: auto !important;
    min-height: 100vh !important;
    max-height: none !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: white !important;
    overflow: visible !important;
    z-index: 999999 !important;
  }
  max-height: 100vh !important;
  max-width: 100vw !important;
  margin: 0 !important; 
  min-height: 550px;
  width: 550px;
`,
)

export const PastTherapyReportDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  @media print{
    display: none;
  }
    max-height: 90vh!important;
    max-width: 1200px!important;
    margin:0px!important; 
    margin: 0 16px !important;
    min-height: 550px;
    width: 100%;
    
    @media (max-width: 768px) {
      margin: 0 !important;
      max-height: 100vh !important;
      height: 100vh !important;
      width: 100vw !important;
      max-width: 100vw !important;
      border-radius: 0 !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
    }
`,
)

function getPageWidthForPageSizeInPx(pageSize) {
  if (pageSize == null) return 794
  if (pageSize === PRINT_PAGE_TYPES.a6) return 395.64
  if (pageSize === PRINT_PAGE_TYPES.a5) return 563.12
  return 794
}

function getPageFontSizeInPx(pageSize) {
  if (pageSize == null) return 18
  if (pageSize === PRINT_PAGE_TYPES.a6) return 13
  if (pageSize === PRINT_PAGE_TYPES.a5) return 16
  return 18
}

export const ReceiptPrintContainer = muiStyled('div')(
  ({ theme, noBorder, biggerFont, pageSize, compatibilityMode = false }) => {
    const pageWidthPx = getPageWidthForPageSizeInPx(pageSize)
    const fontSizePx = getPageFontSizeInPx(pageSize)
    const maxWidthPrint = 'min(' + pageWidthPx + 'px, 100%)'
    return `
@media print {
  display: block !important;
  margin: 0px;
  font-size: ${fontSizePx}px;
  width: 100%;
  max-width: ${maxWidthPrint};
  box-sizing: border-box;
}
  font-weight: ${compatibilityMode ? '600 !important' : 'unset'};
  font-family: ${compatibilityMode ? 'Arial' : 'unset'};
  margin: 0px auto;
  width: 100%;
  max-width: 500.5px;
  height: auto;
  display: flex;
  flex-direction: column;
  font-size: 17px;
  background: #fff;
  color: #000;
  .bordered-portion {
    padding: 12px 14px;
    border: ${noBorder ? '' : '1px solid #000'};
  }
`
  },
)

export const ReceiptPrintMainHeading = muiStyled('h6')(
  ({ theme }) => `
  font-size: 1.1em;
  margin: 0 !important;
  padding: 0;
  text-align: right;
  line-height: 1.2;
`,
)

export const ReceiptPrintBrandHeading = muiStyled('h6')(
  ({ theme }) => `
  font-size: 1.0em;
  text-transform: uppercase;
  margin: 0 0 2px 0;
  line-height: 1.25;
  text-align: center;
`,
)

export const ReceiptPrintClinicSubtext = muiStyled('div')(
  ({ theme }) => `
  font-size: 0.75em;
  margin: 0 0 2px 0;
  line-height: 1.3;
  display: block;
  color: #333;
  text-align: center;
`,
)

export const ReceiptPrintClinicBlock = muiStyled('div')(
  ({ theme }) => `
  font-size: 0.7em;
  margin: 0 0 2px 0;
  line-height: 1.35;
  display: block;
  word-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  text-align: center;
`,
)

export const ReceiptPrintClinicBlockWrapper = muiStyled('div')(
  ({ theme }) => `
  position: relative;
  text-align: center;
  padding-bottom: 4px;
  margin-bottom: 8px;
  border-bottom: 1px solid #000;
`,
)

export const ReceiptPrintMainSubHeading = muiStyled('div')(
  ({ theme }) => `
  font-size: 0.7em;
  display: flex;
  justify-content: space-between;
  align-items: center;
`,
)

export const ReceiptPrintAppointmentDetails = muiStyled('div')(
  ({ theme }) => `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  margin-bottom: 16px;
  align-items: start;
`,
)

export const ReceiptReceiptId = muiStyled('div')(
  ({ theme }) => `
  font-size: 0.7em;
  font-weight: 400;
  text-align: right;
`,
)
export const ReceiptKVPair = muiStyled('div')(
  ({ theme, compatibilityMode }) => `
  font-size: 0.7em;
  display: flex;
  gap: 6px;
  align-items: baseline;
  min-height: 0;
  .key{
    font-weight: 600;
  }
  .value{
    font-weight: 500;
  }
  `,
)

export const KeyItem = muiStyled('div')(
  ({ theme }) => `
  font-weight: 600;
  flex-shrink: 0;
  min-width: 7.5em;
`,
)
export const ValueItem = muiStyled('div')(
  ({ theme }) => `
  font-weight: 500;
  min-width: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`,
)

export const RecieptPriceBreakDownTable = muiStyled('div')(
  ({ theme }) => `
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  font-size: 0.75em;
  margin-bottom: 12px;
  .breakdown-heading {
    border-bottom: 1px solid #c1c0c0;
    font-weight: 600;
    padding: 0.5em 0.25em 0.5em 0;
  }
  .item {
    padding: 0.5em 0.25em 0.5em 0;
  }
  .right-aligned {
    text-align: right;
  }
`,
)

export const ReceiptPrintDialogContent = muiStyled(DialogContent)(
  ({ theme }) => `
  @media print {
    padding: 10px !important;
    margin: 0 !important;
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }
  justify-content: flex-start;
`,
)
